export default __webpack_public_path__ + "static/media/cv1.5247198e.pdf";